<div>
  <app-knowledge-list-page></app-knowledge-list-page>
</div>
